import React from 'react';
import {
    AlertTriangle,
    CheckCircle2,
    CircleAlert,
    Info,
} from 'lucide-react';

const ICON_BY_TYPE = {
    success: { Icon: CheckCircle2, tone: 'success' },
    error: { Icon: CircleAlert, tone: 'error' },
    warning: { Icon: AlertTriangle, tone: 'warning' },
    warn: { Icon: AlertTriangle, tone: 'warning' },
    info: { Icon: Info, tone: 'info' },
    default: { Icon: Info, tone: 'info' },
};

export function AppToastIcon({ type }) {
    const { Icon, tone } = ICON_BY_TYPE[type] || ICON_BY_TYPE.default;

    return (
        <span className="app-toast__icon" data-tone={tone} aria-hidden="true">
            <Icon size={19} strokeWidth={2.4} />
        </span>
    );
}

export default AppToastIcon;
